<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template lang="html">
  <div class="centerx">
    <vs-popup
        class="bulk-update-producer-commissions"
        title="Bulk update producer commissions"
        :active="visible"
        button-close-hidden
    >
      <vue-element-loading v-if="modalLoading" :active="modalLoading"></vue-element-loading>

      <vue-form-generator
          ref="form"
          :model="model"
          :schema="schema"
      />


      <div class="vx-col w-full text-right my-3">
        <vs-button
            class="mr-4 mt-2"
            @click="downloadTemplate"
            color="light"
            :disabled="!model.Company_FK || !model.Company_FK.id"
        >
          Download Template
        </vs-button>
        <vs-button class="ml-3" @click="cancel">
          Cancel
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>

import FormModelMixin from "@/components/mixins/FormModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";
import {selectOptions} from '@/components/form/FormElementOption';
import Vue from 'vue';

export default {
  props: {
    visible: {
      // using visible instead of value (v-model) because of a conflict with FormModelMixin
      type: Boolean,
      default: false
    },
  },
  mixins: [FormModelMixin, NotificationMixin],
  data () {
    return {
      modalLoading: false,
      model: {
        Company_FK: {},
      },
      schema: {
        groups: [
          {
            styleClasses: "vx-row w-full",
            fields: [
              {
                type: "vueMultiSelect",
                inputType: "text",
                styleClasses: "vx-col w-full",
                label: "Producer",
                model: "Company_FK",
                values: () => this.producerOptions.map(( producer ) => {
                  return {
                    id: producer.id,
                    name: `${producer.CompanyCode} - ${producer.name}`,
                  }
                }),
                selectOptions
              },
            ]
          },
        ],
      },
      producerOptions: [],
      options: [
        {
          endpoint: () => this.$api.companies.list(),
          optionsFieldName: "producerOptions",
          nameFieldName: "CompanyName",
          idFieldName: 'id',
          additionalFields: [
            "CompanyCode",
          ],
        },
      ],
    }
  },
  methods: {
    async getTemplate()  {
      try {
        const { data } = await this.$api.clientMap.downloadBulkUpdateProducerTemplate(this.model.Company_FK.id)

        const blob = new Blob([data], { type: this.getFileType('csv') })
        const filename = 'ProducerTemplate.csv';

        const link = document.createElement('a')

        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.click()

        URL.revokeObjectURL(link.href)
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadFileFailureMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    getFileType(extension) {
      let fileType;
      switch (extension) {

        default:
          fileType = 'application/' + extension;
          break;
      }

      return fileType;
    },
    cancel() {
      this.$emit('cancel');
    },
    async downloadTemplate() {
      this.modalLoading = true;

      if (!this.model.Company_FK || !this.model.Company_FK.id) {
        this.notifyWarning('Please select a producer');

        this.modalLoading = false;
        return false;
      }

      try {
        await this.getTemplate();
        this.$emit('updated');
      } catch (e) {
        this.$emit('error', 'Error occurred. Please try again later');
        console.error(e)
      } finally {
        this.modalLoading = false;
      }
    }
  },
}

</script>

<style lang="scss">
.vs-popup--content {
  overflow: visible;
}
</style>
